import { useLayoutEffect, useRef } from "react";

/** A stable reference to the latest committed value for external-data effects. */
export function useLatest<T>(value: T) {
  const reference = useRef(value);
  useLayoutEffect(() => {
    reference.current = value;
  }, [value]);
  return reference;
}
